<div  class="wrapper">
  <div [ngClass]="sourcePage" *ngIf="!hideContent" [ngStyle]="backgroundImage">
    <img *ngIf="sourcePage === LoginUsage.Radar" src="/assets/login/cellphone-icon.svg" height="52.51px" width="40px"/>
    <span class="title">{{title}}</span>
    <ul class="description">
      <li *ngFor="let item of description">
        {{ item }}
      </li>
    </ul>
    <ng-container *ngIf="sourcePage === LoginUsage.HomeEstimator">
      <span class="powered-by" translate="home-estimator.powered-by"></span>
      <img src="/assets/home-estimator/teranet-logo-home.svg" height="25px" width="110px"/>
    </ng-container>  
  </div>
</div>
